import React, { useId, useState } from 'react';


type Props = {
  value: 1  | 0;
  onChange: (v: 1 | 0) => void;
};

export default function ({ value, onChange }: Props){

  const gid = useId(); 

  return (
    <>
      <legend style={{ fontWeight: 600, marginBottom: 8, fontSize:14 }}>Abilitato</legend>

      <div style={{ display: 'flex', gap: 16 }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }} htmlFor={`${gid}-si`}>
          <input
            id={`${gid}-si`}
            type="radio"
            name={`${gid}-abilitato`}
            value="Si"
            checked={value === 1}
            onChange={() => onChange(1)}
            required
          />
          Si
        </label>

        <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }} htmlFor={`${gid}-no`}>
          <input
            id={`${gid}-no`}
            type="radio"
            name={`${gid}-abilitato`}
            value="No"
            checked={value === 0}
            onChange={() => onChange(0)}
            required
          />
          No
        </label>
      </div>
    </>
  );
}
